enum DeductionCalculationMethod {
  FIXED_AMOUNT= 'FIXED_AMOUNT',
  RATE_OF_GROSS_EARNINGS = 'RATE_OF_GROSS_EARNINGS'
}

export default DeductionCalculationMethod;
